module.exports = __webpack_public_path__ + "img/luminor-services-big-mobil.cc68756c.jpg";